import styled from 'styled-components';

export const InfoTooltip = styled.div`
  // width: 196px;
  white-space: normal;
`;
